import styled from "styled-components";

export const ChartContainer = styled.div`
    position: relative;
    box-sizing: border-box;
    height: ${(props) => (props.height ? props.height : "100%")};
    width: ${(props) => (props.width ? props.width : "100%")};
`